import { z } from 'zod/v4';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({
    pausing: z
        .boolean()
        .optional()
        .describe('true = only pausing update types; false = only non-pausing; omit for both.'),
    important: z
        .boolean()
        .optional()
        .describe('true = only "important" update types (ones that trigger further procedures or workflow steps); false = only non-important; omit for both.'),
});
const itemSchema = z.object({
    updateTypeId: z.uuid(),
    label: z.string(),
    aliases: z
        .array(z.string())
        .describe('Translated labels by which this update type may be known.'),
    description: z.string(),
    selectable: z
        .boolean()
        .describe('Whether this type is offered for ordinary manual selection. A false value does not prevent a reviewed proposal, but the type must not be chosen unless the current TASK or TENANT GUIDANCE explicitly requests this exact non-selectable type.'),
    pausing: z.boolean(),
    important: z.boolean(),
    procedureSteps: z.number().int(),
});
const facetsSchema = z.object({
    pausing: z.number().int(),
    important: z.number().int(),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchUpdateTypesTool = {
    name: ToolName.SearchUpdateTypes,
    category: ToolCategory.CaseManagement,
    weight: ToolWeight.Light,
    version: 3,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Search all update TYPES configured for this tenant — the templates that can create pauses, handovers, status changes, promises to pay, follow-ups, and automated workflow transitions. Results include selectable and non-selectable types. `selectable=false` means the type is not offered for ordinary manual selection; do not choose it unless the current TASK or TENANT GUIDANCE explicitly requests that exact non-selectable type. Pick a permitted type matching the situation, then apply via create_update. Call get_update_type for the full procedure a type triggers. To see updates that have actually been applied to the case, use search_updates instead. Note: pause types whose label is "Afventer svar fra X" / "Awaiting reply from X" require a prior outbound interaction to X — verify via search_case_history before proposing one, or send the outbound first. (Domain note: "klient" = creditor.)',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-update-types.js.map